import {
    AfterViewInit,
    Component,
    Input,
    NgModule,
    OnChanges,
    OnDestroy,
    QueryList,
    SimpleChanges,
    ViewChildren
} from '@angular/core';
import {FormModel} from '../../entity/form.model';
import {
    UntypedFormArray,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    FormsModule,
    Validators,
    AbstractControl
} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {CardModule} from '../../../../../core/component/card/card.module';
import {
    GroupFieldsInputComponent,
    GroupFieldsInputModule
} from '../../../../../../components/common/group-fields/group-fields-input/group-fields-input.component';
import {FieldInputModule} from '../../../../../../components/common/field/field-input/field-input.module';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {DatePickerModule} from '../../../../../../components/common/date-picker/date-picker.module';
import {FormDefinitionFieldModel} from '../../../../definition/field/api/entity/formDefinitionField.model';
import {MomentAdapter} from '../../../../../../shared/utils/moment.utils';
import {FieldInputComponent} from '../../../../../../components/common/field/field-input/field-input.component';
import {FormValueModel} from '../../../value/api/entity/formValue.model';
import {
    FormDefinitionGroupWithValuesModel
} from '../../../../definition/group/api/entity/formDefinitionGroupWithValues.model';
import {FormFormSaveComponentService, FormFormSaveComponentServiceFormValue} from './form-form-save-component.service';
import {RichTextEditorModule} from '../../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {
    CommentSummaryFieldModule
} from "../../../../../core/component/comment/comment-summary-field/comment-summary-field.component";
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";
import {ServiceContainerComponent} from "../../../../../core/component/service-container/service-container.component";
import {
    FormDefinitionGetRulesResponse,
    FormDefinitionGetRulesService
} from "../../../../definition/form/api/service/formDefinitionGetRules.service";
import {FormComputeRulesPayloadField, FormComputeRulesService} from "../../service/formComputeRules.service";
import {Subscription} from "rxjs";
import {BaseView} from "../../../../../core/view/base.view";
import {
    FormArrayInputModule
} from "../../../../../../components/common/form-array/form-array-input/form-array-input.module";
import {InputTextModule} from "../../../../../core/component/input-text/input-text.module";
import {Payload} from "../../../../../core/service/payload/payload";
import {PartnerSummaryModel} from "../../../../../partner/common/api/model/partnerSummary.model";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
    selector: 'app-form-form-save',
    template: `
        <app-service-container [service]="formDefinitionGetRulesService">
            <ng-container *ngIf="displayType === 'default'">
                <ng-container *ngIf="!hideGeneralSection">
                    <app-card>
                        <div class="row">
                            <div class="col-12">
                                <h3>Général</h3>
                            </div>
                        </div>
                        <div class="row">
                            <app-form-field label="Date" [required]="true">
                                <app-date-picker [parentFormGroup]='parentFormGroup' parentFormControlName='date'></app-date-picker>
                            </app-form-field>
                            <!-- <ng-content select="[additional-fields]"></ng-content>-->
                        </div>
                        <div class="row">
                            <app-form-field label="Commentaire précédent" size="12" *ngIf="previousComment">
                                <app-comment-summary-field [comment]="previousComment"></app-comment-summary-field>
                            </app-form-field>
                            <app-form-field label="Commentaire" size="12" *ngIf="parentFormGroup.get('comment')">
                                <app-rich-text-editor [parentFormGroup]="parentFormGroup" parentFormControlName="comment"></app-rich-text-editor>
                            </app-form-field>
                        </div>
                    </app-card>
                </ng-container>
                <div class="row">
                    <ng-container *ngFor="let group of groups">
                        <app-form-field [size]="group.definition.fullWidth || group.definition?.fields?.length === 0 ? 12 : col"
                                        [sizeLg]="group.definition.fullWidth || group.definition?.fields?.length === 0 ? 12 : colLgXl"
                                        [sizeXl]="group.definition.fullWidth || group.definition?.fields?.length === 0 ? 12 : colLgXl">
                            <app-group-fields-input [display]="group.definition?.fields?.length === 0 ? 'asTitle' : groupDisplay" [groupModel]="group"
                                                    [componentService]="formFormSaveComponentService"
                                                    [partner]="partner"
                                                    [parentFormArray]="groupsControl()"></app-group-fields-input>
                        </app-form-field>
                    </ng-container>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-card title="Observations libres" *ngIf="parentFormGroup.get('customValues')">
                            <app-form-array-input
                                    [parentFormGroup]="parentFormGroup"
                                    parentFormControlName="customValues"
                                    [buildNewItemForm]="newCustomValueFromHtml"
                                    addItemLabel="Ajouter une observation libre">
                                <ng-template template-content let-itemFormGroup='itemFormGroup'>
                                    <app-form-field label="Observation" [required]="true" [sizeXl]="12" [sizeLg]="12" [size]="12">
                                        <app-input-text [parentFormGroup]="itemFormGroup" parentFormControlName="value"></app-input-text>
                                    </app-form-field>
                                </ng-template>
                            </app-form-array-input>
                        </app-card>
                    </div>
                </div>
                <app-card title="Autres observations" [expandable]='true' [expanded]='true'
                          *ngIf="fields.length > 0">
                    <div class="row">
                        <app-form-field *ngFor="let field of fields; index as i"
                                        size="12"
                                        [sizeXl]="columnsPerRowFields(fields)"
                                        [sizeLg]="columnsPerRowFields(fields)">
                            <app-field-input
                                    [partner]="partner"
                                    [formValue]="field"
                                    [componentService]="formFormSaveComponentService"
                                    [parentFormGroup]="getFieldFormGroupAt(i)"></app-field-input>
                        </app-form-field>
                    </div>
                </app-card>
            </ng-container>
            <ng-container *ngIf="displayType === 'table'">
                <div class="form-array-group">
                    <div class="row m-b-0">
                        <div class="col-12 col-lg-6 col-xl-6">
                            <div class="form-array-row">
                                <div class="form-array-col form-array-label required">Date</div>
                                <div class="form-array-col form-array-col-value">
                                    <app-date-picker [parentFormGroup]='parentFormGroup' parentFormControlName='date'></app-date-picker>
                                </div>
                            </div>
                        </div>
                        <ng-content select="[additional-fields]"></ng-content>
                    </div>
                    <div class="row m-b-0">
                        <div class="col-12 col-lg-6 col-xl-6" *ngIf="previousComment">
                            <div class="form-array-row">
                                <div class="form-array-col form-array-label required" matTooltip="Commentaire précédent">Commentaire précédent</div>
                                <div class="form-array-col form-array-col-value">
                                    <app-comment-summary-field [comment]="previousComment"></app-comment-summary-field>
                                </div>

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-array-row">
                                <div class="form-array-col form-array-label required" matTooltip="Commentaire">Commentaire</div>
                                <div class="form-array-col form-array-col-value">
                                    <app-rich-text-editor [parentFormGroup]="parentFormGroup" parentFormControlName="comment"></app-rich-text-editor>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                
                <ng-container *ngFor="let group of groups">
                    <div class="form-array-group">
                        <div class="text-center form-array-group-title">
                            {{group.definition.label}}
                        </div>
                        <app-group-fields-input displayType="table" [groupModel]="group"
                                                [componentService]="formFormSaveComponentService"
                                                [partner]="partner"
                                                [parentFormArray]="groupsControl()"></app-group-fields-input>
                    </div>
                </ng-container>
            </ng-container>
            <div class="form-array-group" *ngIf="parentFormGroup.get('customValues')">
                <div class="text-center form-array-group-title">
                    Observations libres
                </div>
                <app-form-array-input
                        [parentFormGroup]="parentFormGroup"
                        parentFormControlName="customValues"
                        [buildNewItemForm]="newCustomValueFromHtml"
                        addItemLabel="Ajouter une observation libre">
                    <ng-template template-content let-itemFormGroup='itemFormGroup'>
                        <div class="m-y-4">
                            <app-form-field label="Observation" [required]="true" [sizeXl]="12" [sizeLg]="12" [size]="12">
                                <app-input-text [parentFormGroup]="itemFormGroup" parentFormControlName="value"></app-input-text>
                            </app-form-field>
                        </div>
                    </ng-template>
                </app-form-array-input>
            </div>
            <div class="form-array-group" *ngIf="fields.length">
                <div class="text-center form-array-group-title">
                    Autres observations
                </div>
                <ng-container *ngFor="let field of fields; index as i">
                    <ng-container *ngIf="i % 2 === 0">
                        <div class="row m-b-0">
                            <div class="col-12 col-lg-6 col-xl-6">
                                <div class="form-array-row">
                                    <div class="form-array-col form-array-label" [matTooltip]="field.label">{{ field.label }}</div>
                                    <div class="form-array-col form-array-col-value">
                                        <app-field-input
                                                [size]="12"
                                                [sizeXl]="12"
                                                [sizeLg]="12"
                                                [formValue]="field"
                                                displayType="compact"
                                                [componentService]="formFormSaveComponentService"
                                                [parentFormGroup]="getFieldFormGroupAt(i)"
                                                [partner]="partner">
                                        </app-field-input>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="fields.length > i + 1">
                                <div class="col-12 col-lg-6 col-xl-6">
                                    <div class="form-array-row">
                                        <div class="form-array-col form-array-label" [matTooltip]="fields[i+1].label">{{ fields[i+1].label }}</div>
                                        <div class="form-array-col form-array-col-value">
                                            <app-field-input
                                                    displayType="compact"
                                                    [size]="12"
                                                    [sizeXl]="12"
                                                    [sizeLg]="12"
                                                    [formValue]="fields[i+1]"
                                                    [componentService]="formFormSaveComponentService"
                                                    [parentFormGroup]="getFieldFormGroupAt(i+1)"
                                                    [partner]="partner">
                                            </app-field-input>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </app-service-container>
        `,
    providers: [
        FormFormSaveComponentService,
        FormDefinitionGetRulesService,
        FormComputeRulesService
    ]
})
export class FormFormSaveComponent extends BaseView implements OnChanges, OnDestroy, AfterViewInit {

    @Input() displayType: 'default' | 'table' = 'default';
    @Input() groupDisplay: 'asCard' | 'asTitle' = 'asTitle';
    @Input() hideGeneralSection = false;
    @Input('formModel') inputFormModel: FormModel;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() allCardsExpanded = true;
    @Input() previousComment: string;
    @Input() partner: PartnerSummaryModel;

    @ViewChildren(GroupFieldsInputComponent) groupsComponents: QueryList<GroupFieldsInputComponent>;
    @ViewChildren(FieldInputComponent) fieldsComponents: QueryList<FieldInputComponent>;
    values: FormFormSaveComponentServiceFormValue[] = [];
    groups: FormDefinitionGroupWithValuesModel[] = [];
    fields: FormValueModel[] = [];
    col: number;
    colLgXl: number;
    rulesByFieldDefinitionIds = new Map<number, FormDefinitionGetRulesResponse[]>()
    subscriptions: Subscription[] = [];
    constructor(private formBuilder: UntypedFormBuilder,
                public formFormSaveComponentService: FormFormSaveComponentService,
                public formDefinitionGetRulesService: FormDefinitionGetRulesService,
                public formComputeRulesService: FormComputeRulesService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['allCardsExpanded']) {
            // console.log(['all card expanded', this.allCardsExpanded]);
            this.formFormSaveComponentService.setAllCardExpanded(this.allCardsExpanded);
        }

        if (changes['parentFormGroup'] && changes['parentFormGroup'].currentValue) {
            this.parentFormGroup.addControl('date', new UntypedFormControl(MomentAdapter.current().get(), Validators.required));
        }
        if (changes['inputFormModel'] && changes['inputFormModel'].currentValue && this.parentFormGroup) {
            if (this.inputFormModel.summary?.date) {
                this.parentFormGroup.get('date').setValue(this.inputFormModel.summary.date);
            }

            const customValueFormArray = this.formBuilder.array([]);

            this.parentFormGroup.addControl('formDefinition', new UntypedFormControl(this.inputFormModel.formDefinition));
            this.parentFormGroup.addControl('groups', this.formBuilder.array([]));
            this.parentFormGroup.addControl('fields', this.formBuilder.array([]));
            this.parentFormGroup.addControl('comment', this.formBuilder.control(undefined));
            this.parentFormGroup.addControl('customValues', customValueFormArray);

            this.formDefinitionGetRulesService.executeAction({
                formDefinitionId: this.inputFormModel.formDefinition.summary.id,
                versionId: this.inputFormModel.formDefinition.versionNumber
            }).then((values: FormDefinitionGetRulesResponse[]) => this.onRulesLoaded(values));

            this.inputFormModel.customValues.forEach(value =>
                customValueFormArray.push(this.formBuilder.group({
                    value
                })));

            this.groups = this.inputFormModel.formDefinition.groups.map(groupDefinition => {
                const fields: FormValueModel[] = [];
                if (this.inputFormModel.values.length === 0) {
                    groupDefinition.fields.forEach(value => {
                        if (value.defaultValue) {
                            fields.push({
                                value: value.defaultValue,
                                fieldDefinition: value.fieldDefinition,
                                label: value.label,
                                id: undefined,
                                document: undefined,
                                comment: undefined,
                            });
                        }
                    });
                } else {
                    this.inputFormModel.values.forEach(value => {
                        // console.log([value, groupDefinition.fields]);
                        if (groupDefinition.fields.findIndex(
                            field => field.fieldDefinition.summary.id === value.fieldDefinition.summary.id) > -1){
                            fields.push(value);
                        }
                    });
                }
                return {
                    definition: groupDefinition,
                    values: fields
                };
            });
            // this.groups = this.formModel.formDefinition.groups;
            this.groups.sort((a, b) => a.definition.index - b.definition.index);


            const formDefinitionAllFields = this.resolveAllFields();
            // Add fields not in definition
            this.fields = [];
            this.inputFormModel.values.forEach(value => {
                if (formDefinitionAllFields
                    .findIndex(fieldDefinition => fieldDefinition.summary.id === value.fieldDefinition.summary.id) < 0) {
                    this.fields.push(value);
                }
            });
            this.fields.forEach(field => {
                this.fieldsControl.push(this.formBuilder.group({}));
            });

            // populate form value if some are mising according to definition
            formDefinitionAllFields.forEach(fieldDefinition => {
                if (this.inputFormModel.values.findIndex(value => value.fieldDefinition.summary.id === fieldDefinition.summary.id) < 0) {
                    this.inputFormModel.values.push({
                        value: undefined,
                        fieldDefinition,
                        label: 'label',
                        id: undefined,
                        document: undefined,
                        comment: undefined,
                    });
                }
            });

            console.log('inputFormModel', this.inputFormModel);
            this.inputFormModel.values.forEach((value) => this.values.push({
                value: value.value,
                valueForRule: undefined,
                fieldDefinitionId: value.fieldDefinition.summary.id,
                fieldDefinitionName: value.fieldDefinition.summary.name
            }));

            console.log('INIT', this.values);
        }

        this.col = 12;
        this.colLgXl = 6;
        if (this.groups?.length === 1) {
            this.colLgXl = 12;
        }
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.formFormSaveComponentService.inputChangedFormValue$.subscribe(value => {
            if (value) {
                const existingValue = this.values.find(value1 => value.fieldDefinitionId === value1.fieldDefinitionId);
                if (existingValue) {
                    existingValue.value = value.value;
                    existingValue.valueForRule = value.valueForRule;
                }

                // Need to apply rules?
                const rules = this.rulesByFieldDefinitionIds.get(value.fieldDefinitionId);
                if (rules && rules.length > 0) {
                    const ruleDefinitionNames: string[] = [];
                    const fields: FormComputeRulesPayloadField[] = [];
                    rules.forEach(rule =>  {
                        ruleDefinitionNames.push(rule.name);
                        rule.srcFields.forEach(srcField => {
                            if (fields.findIndex(field => field.fieldDefinitionId === srcField.fieldId) === -1) {
                                fields.push({
                                    fieldDefinitionId: srcField.fieldId,
                                    value: this.values.find(value1 => value1.fieldDefinitionId === srcField.fieldId)?.valueForRule,
                                })
                            }
                        })
                    })
                    console.log([fields]);
                    this.formComputeRulesService.executeAction({
                        fields,
                        ruleDefinitionNames
                    }).then(result => {
                        console.log(result);
                        result.forEach(value1 => {
                            const matchingValue = this.values.find(value2 => value2.fieldDefinitionName === value1.fieldDefinitionName);
                            console.log([matchingValue]);
                            if (matchingValue) {
                                matchingValue.value = value1.value;
                                this.formFormSaveComponentService.setChangedValue(matchingValue);
                            }
                        })
                    }).catch(e => this.toastControl.presentError(e, 'Les règles n\'ont pu être appliquées'));
                }
            }
        }));
    }



    ngOnDestroy(): void {
        this.subscriptions.forEach(value => value.unsubscribe());
    }

    newCustomValueFromHtml = (): UntypedFormGroup => {
        return this.formBuilder.group({
            value: this.formBuilder.control(undefined, Validators.required),
        })
    }



    onRulesLoaded(rules: FormDefinitionGetRulesResponse[]) {
        this.rulesByFieldDefinitionIds.clear();
        const formDefinitionAllFields = this.resolveAllFields();

        rules.forEach(rule => {
            // Check all fields exists
            let allFieldsExist = true;
            rule.srcFields.forEach(value => {
                if (formDefinitionAllFields.findIndex(value1 => value1.summary.id === value.fieldId) === -1){
                    allFieldsExist = false;
                }
            });
            console.log('All fields exists ?', allFieldsExist);
            if (allFieldsExist) {
                rule.srcFields.forEach(value => {
                    let matchingRules = this.rulesByFieldDefinitionIds.get(value.fieldId);
                    if (!matchingRules) {
                        matchingRules = [];
                        this.rulesByFieldDefinitionIds.set(value.fieldId, matchingRules);
                    }
                    matchingRules.push(rule);
                })
            }
        });
        console.log(['rulesByFieldDefinitionIds', this.rulesByFieldDefinitionIds]);
    }
    groupsControl(): UntypedFormArray {
        return this.parentFormGroup.get('groups') as UntypedFormArray;
    }

    get fieldsControl(): UntypedFormArray {
        return this.parentFormGroup.get('fields') as UntypedFormArray;
    }

    getFieldFormGroupAt(index: number): UntypedFormGroup {
        return this.fieldsControl.at(index) as UntypedFormGroup;
    }

    columnsPerRowFields(elements: any[]) {
        if (elements.length <= 1) {
            return 12; // 1 seul element sur toute la ligne
        }
        if (elements.length === 2) {
            return 6; // 2 éléments sur toute la ligne
        }
        if (elements.length === 3) {
            return 4; // 3 éléments sur toute la ligne
        }
        return 3; // 4 éléments par ligne
    }

    focusOnField(fieldId: number) {
        this.findFieldComponent(fieldId)?.focus();
    }


    private findFieldComponent(fieldId: number): FieldInputComponent {
        const field = this.fieldsComponents.find(fieldComponent => fieldId === fieldComponent.fieldId());
        if (!field) {
            return this.groupsComponents.map(groupComponent => groupComponent.findFieldComponent(fieldId))
                .reduce((a, b) => b);
        }
        return field;
    }

    resolveAllFields(): FormDefinitionFieldModel[]  {
        const formDefinitionAllFields: FormDefinitionFieldModel[] = [];
        this.inputFormModel.formDefinition.groups.forEach(gr => gr.fields.forEach(field => {
            formDefinitionAllFields.push(field.fieldDefinition);
        }));
        this.inputFormModel.formDefinition.fields.forEach(field => formDefinitionAllFields.push(field.fieldDefinition));
        return formDefinitionAllFields;
    }

    buildPayload(): FormFormSavePayload {
        return {
            formDefinitionId: this.inputFormModel.formDefinition.summary.id,
            values: this.allFields().map(abstractControl => {
                let value = abstractControl.get('value').value;
                if (abstractControl.get('measured').value === false) {
                    value = undefined;
                }
                return {
                    fieldDefinitionName : abstractControl.get('name').value,
                    value,
                    comment: abstractControl.get('comment').value
                }
            })
        }
    }

    private allFields(): AbstractControl[] {
        const fieldsArrayForm: UntypedFormArray = this.parentFormGroup.get('fields') as UntypedFormArray;
        const groupsArrayForm: UntypedFormArray = this.parentFormGroup.get('groups') as UntypedFormArray;
        return fieldsArrayForm.controls
            .concat(groupsArrayForm.controls
                .map((group: UntypedFormGroup) => group.get('fields') as UntypedFormArray)
                .map((fieldFormArray: UntypedFormArray) => fieldFormArray.controls)
                .reduce((a, b) => a.concat(b), [])
            );
    }

}

export class FormFormSavePayload implements Payload {
    formDefinitionId: number;
    values: FormFormSaveValuePayload[] = [];
}

export class FormFormSaveValuePayload implements Payload {
    fieldDefinitionName: string;
    value: any;
    comment: string;
}


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CardModule,
        GroupFieldsInputModule,
        FieldInputModule,
        FormFieldModule,
        DatePickerModule,
        RichTextEditorModule,
        CommentSummaryFieldModule,
        LoadingModule,
        ServiceContainerComponent,
        FormArrayInputModule,
        InputTextModule,
        MatTooltipModule,
    ],
    declarations: [FormFormSaveComponent],
    exports: [
        FormFormSaveComponent
    ]
})
export class FormFormSaveModule {}

